import { Button, ButtonProps } from '@components/primitives/Button';

/** A `Button` with the presets an addon expects. */
export function InputGroupButton({
  type = 'button',
  variant = 'secondary',
  size = '2xs',
  ghost = true,
  ...props
}: ButtonProps) {
  return (
    <Button
      type={type}
      variant={variant}
      size={size}
      ghost={ghost}
      {...props}
    />
  );
}
